import routes from '@configs/routes.json';
import { get } from '@services/method';

export class AccountsService {
  static getUserAccountsV2 = async () => {
    return await get(routes.api.accountsV2.get).then((response) =>
      response.json()
    );
  };

  static getProjectsByAccountId = async (accountId: string) => {
    const url = await routes.api.projects.get.replace(':accountId', accountId);
    return get(url).then((response) => response.json());
  };

  static getProjects = () => {
    // const url = routes.api.projects.current;
    return get('/app/projects').then((response) => response.json());
  };
}
